import { useSelector } from 'react-redux';
import { OrderedMap } from 'immutable';

// Hooks
import { useMember } from './use-member';

// Types
import { RequireOnlyOne } from 'Shared/types/_RequireOnlyOne.type';
import { User } from 'Shared/constants/types';

// Selectors
import { getUserByUserId, getUserByUserSlug } from 'Shared/selectors/Users.selectors';

interface UseUserProps {
  id?: number;
  slug?: string;
}

type Props = RequireOnlyOne<UseUserProps, 'id' | 'slug'>;

export const useUser = ({ id, slug }: Props) => {
  const userById = useSelector(state =>
    getUserByUserId(state, {
      userId: id,
    })
  );

  const userBySlug = useSelector(state =>
    getUserByUserSlug(state, {
      userSlug: slug,
    })
  );

  const userOrderedMap = userById || userBySlug || OrderedMap();
  const user: User = userOrderedMap.isEmpty() ? null : userOrderedMap.toJS();
  const isPiUser = !!user?.piUserGuid;
  const { isThirdPartyUser } = useMember({ slug: user?.slug });

  return {
    user,
    displayName: user?.displayName,
    id: user?.id,
    slug: user?.slug,
    isPiUser,
    isThirdPartyUser,
  };
};
